// WebViewContext

import { createContext, useContext } from "react";

export interface IWebViewContext {
  isWebView: boolean;
}

const WebViewContext = createContext<IWebViewContext>({ isWebView: false });

const useWebViewContext = (): IWebViewContext => {
  const context = useContext(WebViewContext);
  if (!context) {
    throw new Error("useWebViewContext must be used within a WebViewProvider");
  }
  return context;
};

export default WebViewContext;

export { useWebViewContext };
